export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "development",
  NEXT_PUBLIC_BASE_URL: "https://www.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://www.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "corporate",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  NEXT_PUBLIC_CF_MXP_ENVIRONMENT: "personalization",
  NEXT_PUBLIC_RENDER_NAV: true,
  NEXT_PUBLIC_RENDER_FOOTER: true,
  NEXT_PUBLIC_PRERENDER_ARTICLES: true,
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: true,
  NEXT_PUBLIC_PRERENDER_CUSTOMERSTORIES: true,
  NEXT_PUBLIC_PRERENDER_DOCS: true,
  NEXT_PUBLIC_PREVIEW_DATA: false,
  NEXT_PUBLIC_ONETRUST_ID: "c4b867da-0106-4cc2-85ba-b4958ea10d7e",
}
